export default __webpack_public_path__ + "static/media/riskScreenshot.858e8ce7.png";